export default __webpack_public_path__ + "static/media/amy.f68c6c09.png";